<template lang="pug">
shListData(title="Casos de fraude cerrados" resolver="fraudCasesClosed" keyData="_id" component="shFraudCase")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'FraudCasesClosed',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fraudCase/FraudCasesClosed.vue